/**
 * 탭 화면의 마지막 콘텐츠와 하단 메뉴 사이 여백입니다.
 * 지도 장소 상세 바텀시트의 마지막 여백과 같은 값으로 유지합니다.
 */
export const TAB_CONTENT_BOTTOM_GAP = 40;
